// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 123) return "theme/js/app/icons.js";
	if (chunkId === 808) return "theme/js/app/carousels.js";
	if (chunkId === 522) return "theme/js/app/maps.js";
	if (chunkId === 614) return "theme/js/app/sessionTimeout.js";
	// return url for filenames based on template
	return undefined;
};